// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Asynchronously wait for a specified number of milliseconds.
export const delay = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));
